<template>
    <div class="personal_center">
        <div class="warp1200 fix">
            <PersonalCenterMenu :activeIndex="2" />
            <div class="f-fr center_right">
                <coupon-list ref="list" :isExpired="isExpired"></coupon-list>

                <!-- 航线推荐 -->
                <promo-cruise></promo-cruise>
            </div>
        </div>
    </div>
</template>

<script>
    import PersonalCenterMenu from '@/components/User/PersonalCenterMenu'
    import PromoCruise from '@/components/Cruise/PromoCruise'
    import CouponList from '@/components/User/CouponList'

    export default {
        name: 'UserCoupon',
        components: {
            PersonalCenterMenu,
            PromoCruise,
            CouponList,
        },
        data: () => {
            return {
                isExpired: 1,
            }
        },
        beforeMount () {
            this.init()
        },
        methods: {
            async init () {
                await this.initPage()
            },
            async initPage () {
                const userToken = this.$store.state.user.userToken
                if (!userToken) {
                    this.$router.push(`/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(window.location.pathname)}`)
                    return false
                }

                this.isExpired = parseInt(this.$route.query.isExpired)
            },
        }
    }
</script>

<style lang="less" scoped>
    .personal_center {
        background: #f5f5f5;
        .center_right{
            width: 945px;
            margin-top: 20px;
        }
    }
</style>
